export const LEADENGINEER = {
    API: 'LeadEngineer'
}

export const LEADENGINEERAPIConstant = {
    getByCAI: LEADENGINEER.API + '/GetDataByCAI', // Get OA by CAI (right table data)
    getAll : LEADENGINEER.API + '/GetAllData',
    getAssignedDetails : LEADENGINEER.API + '/GetAssignedData',
    Save : LEADENGINEER.API + '/Save',
    Update : LEADENGINEER.API + '/Update',
}